module.exports = __webpack_public_path__ + "img/img9.281da24d.svg";